import { defineVariants } from "@/runtime/style-engine/define-variants";

export const accordionRootClasses = defineVariants({
  base: "flex flex-col gap-4 w-full",
  variants: {
    group: {
      true: "gap-0!",
      false: "",
    },
  },
});

export const accordionDetailsClasses = defineVariants({
  base: "rounded-[inherit] has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-[-2px] has-[:focus-visible]:outline-(--color-foreground)",
  variants: {},
});

export const accordionSummaryClasses = defineVariants({
  base: "w-full flex items-center gap-2 cursor-pointer list-none [&::-webkit-details-marker]:hidden border-b border-transparent hover:bg-(--card-color)/5 transition-colors duration-75 focus-visible:outline-none",
  variants: {
    size: {
      xs: "p-2",
      sm: "p-3",
      md: "p-4",
      lg: "p-5",
      xl: "p-6",
    },
    variant: {
      transparent: "border-(--color-elevation-200)!",
      solid: "hover:bg-white/10!",
    },
    disabled: {
      true: "opacity-50 cursor-not-allowed!",
      false: "",
    },
    open: {
      true: "",
      false: "",
    },
  },
  defaults: {
    size: "sm",
    disabled: false,
    open: false,
  },
  compoundVariants: [
    {
      variant: "solid",
      open: true,
      class: "border-(--color-foreground)/20!",
    },
    {
      variant: "transparent",
      open: [true, false],
      class: "border-(--color-elevation-200)!",
    },
    {
      variant: ["*", "!solid", "!transparent"],
      open: true,
      class: "border-(--color-foreground)/15!",
    },
  ],
});

export const accordionIndicatorClasses = defineVariants({
  base: "transition-transform duration-200 rotate-90",
  variants: {
    open: {
      true: "rotate-180",
      false: "rotate-90",
    },
  },
  defaults: {
    open: false,
  },
});

export const accordionContentClasses = defineVariants({
  base: "",
  variants: {
    size: {
      xs: "px-2 pt-2 pb-2",
      sm: "px-3 pt-3 pb-3",
      md: "px-4 pt-4 pb-4",
      lg: "px-5 pt-5 pb-5",
      xl: "px-6 pt-6 pb-6",
    },
    variant: {
      transparent: "",
    },
  },
  defaults: {
    size: "sm",
  },
});
